// Direcciones guardadas -- requiere cuenta (JWT), no existen para
// invitados. Mismo patrón que auth.js: el JWT viaja como `?token=...`.
import { request } from './ecommerceClient';
import { getStoredAuth } from './auth';

const authParams = () => {
  const { token } = getStoredAuth();
  return token ? { token } : {};
};

export const getDirecciones = async () => {
  const data = await request('/direcciones', { params: authParams() });
  return data.items || [];
};

// `direccion` = {alias, name, address, department, city, postalCode, phone,
// email} (misma forma que produce CustomerForm.jsx, más `alias`).
// El backend resetea `predeterminada` a false si no viene en el body, así
// que hay que reenviar el valor actual al editar (si no, un update saca la
// dirección de "predeterminada" sin que nadie lo haya pedido).
const direccionBody = ({ alias, direccion, predeterminada }) => ({
  alias,
  nombre_completo: direccion.name,
  direccion: direccion.address,
  departamento: direccion.department,
  ciudad: direccion.city,
  codigo_postal: direccion.postalCode?.trim() || 'S/N',
  telefono: direccion.phone,
  email: direccion.email,
  predeterminada: Boolean(predeterminada),
});

export const crearDireccion = ({ alias, direccion, predeterminada }) =>
  request('/direcciones', {
    method: 'POST',
    params: authParams(),
    body: JSON.stringify(direccionBody({ alias, direccion, predeterminada })),
  });

export const actualizarDireccion = (id, { alias, direccion, predeterminada }) =>
  request(`/direcciones/${id}`, {
    method: 'PUT',
    params: authParams(),
    body: JSON.stringify(direccionBody({ alias, direccion, predeterminada })),
  });

export const eliminarDireccion = (id) =>
  request(`/direcciones/${id}`, {
    method: 'DELETE',
    params: authParams(),
  });
